(() => {
  if (window.__M42_PAGE_SCRIPT_LOADED__) return;
  window.__M42_PAGE_SCRIPT_LOADED__ = true;
  const money = (cents) => new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD'
  }).format((Number(cents) || 0) / 100);

  const q = (root, selector) => root ? root.querySelector(selector) : null;
  const qa = (root, selector) => root ? Array.from(root.querySelectorAll(selector)) : [];
  const clamp = (value, min = 0, max = 1) => Math.max(min, Math.min(max, value));

  function showToast(root, title, text) {
    const toast = q(root, '[data-m42-toast]');
    if (!toast) return;
    const titleEl = q(toast, '[data-m42-toast-title]');
    const textEl = q(toast, '[data-m42-toast-text]');
    if (titleEl) titleEl.textContent = title;
    if (textEl) textEl.textContent = text;
    toast.classList.add('show');
    clearTimeout(toast._m42Timer);
    toast._m42Timer = setTimeout(() => toast.classList.remove('show'), 3400);
  }


  function fireCartEvent(name, detail) {
    const targets = [document.documentElement, document, document.body].filter(Boolean);
    targets.forEach((target) => {
      try {
        target.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
      } catch (_) {}
    });
  }

  function updateVisibleCartValues(cart) {
    const count = Number(cart?.item_count || 0);
    const total = Number(cart?.total_price || 0);

    const countSelectors = [
      '[data-cart-count]',
      '[data-cart-item-count]',
      '.cart-count',
      '.cartCount',
      '.js-cart-count',
      '.site-header__cart-count',
      '.Header__CartCount',
      '.cart-link__bubble-num',
      '.hc-items-count',
      '#CartCount',
      '#cartCount'
    ];

    document.querySelectorAll(countSelectors.join(',')).forEach((element) => {
      const innerCount = element.matches('#CartCount, #cartCount')
        ? element.querySelector('span')
        : null;
      const target = innerCount || element;
      target.textContent = String(count);
      element.hidden = false;
      element.classList.remove('hidden', 'hidden-count', 'is-empty');
    });

    const totalSelectors = [
      '[data-cart-total]',
      '[data-cart-subtotal]',
      '#cart-price',
      '.cart-total .money',
      '.cart__subtotal .money',
      '.mini-cart__total .money',
      '.hc-buttons .amount'
    ];

    document.querySelectorAll(totalSelectors.join(',')).forEach((element) => {
      element.textContent = money(total);
    });
  }

  async function refreshCartDrawerMarkup(rootPath) {
    const response = await fetch(`${rootPath}cart`, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      cache: 'no-store'
    });

    if (!response.ok) return false;

    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const selectors = [
      '#sidebar-cart',
      '#CartDrawer',
      '#cartDrawer',
      '#cart-drawer',
      '#mini-cart',
      '[data-cart-drawer]',
      '.cart-drawer',
      '.mini-cart-popup'
    ];

    let replaced = false;
    const handled = new Set();

    selectors.forEach((selector) => {
      const current = document.querySelector(selector);
      const incoming = parsed.querySelector(selector);
      if (!current || !incoming || handled.has(current)) return;
      current.innerHTML = incoming.innerHTML;
      handled.add(current);
      replaced = true;
    });

    return replaced;
  }

  function openThemeCart(detail) {
    fireCartEvent('cart:open', detail);
    fireCartEvent('theme:cart:open', detail);
    fireCartEvent('drawer:open', { ...detail, drawer: 'cart' });

    const possibleOpeners = [
      '[data-action="toggle-mini-cart"]',
      '[data-action="open-cart"]',
      '[data-cart-toggle]',
      '.js-open-cart',
      '.slide_out_cart_trigger',
      '[aria-controls="sidebar-cart"]',
      '[aria-controls="CartDrawer"]',
      '[aria-controls="cart-drawer"]'
    ];

    const opener = possibleOpeners
      .map((selector) => document.querySelector(selector))
      .find((element) => {
        if (!element) return false;
        if (element.tagName === 'BUTTON') return true;
        const href = element.getAttribute('href') || '';
        return href === '' || href === '#' || href.startsWith('javascript:');
      });

    if (opener) {
      try { opener.click(); } catch (_) {}
    }
  }

  async function refreshThemeCart(rootPath, cart, addResult) {
    const addedItem = Array.isArray(addResult?.items) ? addResult.items[0] : addResult;
    const detail = {
      cart,
      item: addedItem,
      openMiniCart: true,
      source: 'nomo-kool-40'
    };

    updateVisibleCartValues(cart);

    fireCartEvent('cart:refresh', detail);
    fireCartEvent('cart:updated', detail);
    fireCartEvent('cart:update', detail);
    fireCartEvent('theme:cart:added', detail);
    fireCartEvent('product:added', detail);

    if (window.jQuery) {
      try {
        window.jQuery(document).trigger('cart:refresh', [cart]);
        window.jQuery(document.body).trigger('added.ajaxProduct', [addedItem]);
        window.jQuery(document.body).trigger('afterCartLoad.ajaxCart', [cart]);
      } catch (_) {}
    }

    try {
      if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
        window.ajaxCart.load();
      } else if (window.theme?.ajaxCart && typeof window.theme.ajaxCart.load === 'function') {
        window.theme.ajaxCart.load();
      } else {
        await refreshCartDrawerMarkup(rootPath);
      }
    } catch (_) {
      try { await refreshCartDrawerMarkup(rootPath); } catch (_) {}
    }

    updateVisibleCartValues(cart);
    openThemeCart(detail);
  }

  function initHero(root) {
    const hero = q(root, '[data-m42-hero]');
    if (!hero || hero.dataset.m42Ready === 'true') return;
    hero.dataset.m42Ready = 'true';

    const mainImage = q(hero, '[data-m42-main-image]');
    const visual = q(hero, '[data-m42-main-visual]');

    qa(hero, '[data-m42-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        qa(hero, '[data-m42-thumb]').forEach((item) => item.classList.remove('active'));
        thumb.classList.add('active');
        const url = thumb.dataset.imageUrl;
        if (!mainImage || !url) return;
        mainImage.style.opacity = '.15';
        window.setTimeout(() => {
          mainImage.src = url;
          mainImage.alt = thumb.dataset.imageAlt || mainImage.alt;
          mainImage.style.opacity = '1';
        }, 150);
      });
    });

    if (visual && mainImage && window.matchMedia('(pointer:fine)').matches) {
      visual.addEventListener('pointermove', (event) => {
        const rect = visual.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - .5;
        const y = (event.clientY - rect.top) / rect.height - .5;
        mainImage.style.transform = `scale(1.06) translate(${x * -14}px, ${y * -10}px)`;
      });
      visual.addEventListener('pointerleave', () => {
        mainImage.style.transform = 'scale(1)';
      });
    }

    const form = q(hero, '.m42-product-form');
    const variantsScript = q(root, '[data-m42-variants]');
    const optionsScript = q(root, '[data-m42-option-names]');
    if (!form || !variantsScript || !optionsScript) return;

    let variants = [];
    let optionNames = [];
    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
      optionNames = JSON.parse(optionsScript.textContent || '[]');
    } catch (error) {
      console.error('All Green 40 variant data could not be read.', error);
      return;
    }

    if (!Array.isArray(variants) || !variants.length) {
      console.error('All Green 40 has no readable variants.');
      return;
    }

    const normalise = (value) => String(value ?? '').trim();
    const numericMetres = (value) => {
      const match = normalise(value).match(/[\d.]+/);
      return match ? Number(match[0]) : 0;
    };
    const sameOption = (left, right) => normalise(left) === normalise(right);

    const detectedWidthIndex = optionNames.findIndex((name) => normalise(name).toLowerCase().includes('width'));
    const detectedLengthIndex = optionNames.findIndex((name) => normalise(name).toLowerCase().includes('length'));
    const widthIndex = detectedWidthIndex >= 0 ? detectedWidthIndex : 0;
    const lengthIndex = detectedLengthIndex >= 0 ? detectedLengthIndex : Math.min(1, Math.max(0, optionNames.length - 1));

    const widthButtons = qa(hero, '[data-m42-width]');
    const lengthSelect = q(hero, '[data-m42-length]');
    const variantInput = q(form, 'input[name="id"]');
    const quantityInput = q(form, 'input[name="quantity"]');
    const quantityOutput = q(hero, '[data-m42-qty-output]');
    const addButton = q(form, '[data-m42-add]');
    const stickyAdd = q(root, '[data-m42-sticky-add]');

    if (!widthButtons.length || !lengthSelect || !variantInput || !quantityInput) return;

    const variantWidthValues = [...new Set(
      variants.map((variant) => normalise(variant.options?.[widthIndex])).filter(Boolean)
    )].sort((a, b) => numericMetres(a) - numericMetres(b));

    widthButtons.forEach((button) => {
      const currentValue = normalise(button.dataset.optionValue);
      const currentNumber = numericMetres(currentValue || button.textContent);
      const exact = variantWidthValues.find((value) => sameOption(value, currentValue));
      const numericMatch = variantWidthValues.find((value) => numericMetres(value) === currentNumber);
      const resolved = exact || numericMatch;
      if (resolved) button.dataset.optionValue = resolved;
    });

    let activeWidthButton = widthButtons.find((button) => button.classList.contains('active'));
    if (!activeWidthButton || !variantWidthValues.some((value) => sameOption(value, activeWidthButton.dataset.optionValue))) {
      activeWidthButton = widthButtons.find((button) => numericMetres(button.dataset.optionValue) === 4) || widthButtons[0];
    }
    widthButtons.forEach((button) => button.classList.toggle('active', button === activeWidthButton));

    let quantity = Math.max(1, Number(quantityInput.value || 1));
    let preferredLengthNumber = numericMetres(lengthSelect.value) || 10;

    function selectedWidth() {
      return normalise(widthButtons.find((button) => button.classList.contains('active'))?.dataset.optionValue);
    }

    function availableLengthValues(widthValue) {
      const values = variants
        .filter((variant) => sameOption(variant.options?.[widthIndex], widthValue))
        .map((variant) => normalise(variant.options?.[lengthIndex]))
        .filter((value) => value && numericMetres(value) > 0);

      return [...new Set(values)].sort((a, b) => numericMetres(a) - numericMetres(b));
    }

    function rebuildLengthOptions(preferredNumber = preferredLengthNumber) {
      const lengths = availableLengthValues(selectedWidth());
      const previousValue = normalise(lengthSelect.value);
      lengthSelect.innerHTML = '';

      lengths.forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        lengthSelect.appendChild(option);
      });

      const exactPrevious = lengths.find((value) => sameOption(value, previousValue));
      const preferred = lengths.find((value) => numericMetres(value) === preferredNumber);
      lengthSelect.value = exactPrevious || preferred || lengths[0] || '';
      preferredLengthNumber = numericMetres(lengthSelect.value) || preferredLengthNumber;
    }

    function selectedLength() {
      return normalise(lengthSelect.value);
    }

    function findVariant() {
      const width = selectedWidth();
      const length = selectedLength();
      return variants.find((variant) => {
        const options = variant.options || [];
        return sameOption(options[widthIndex], width) && sameOption(options[lengthIndex], length);
      }) || null;
    }

    function updateOrder() {
      const variant = findVariant();
      const width = numericMetres(selectedWidth());
      const length = numericMetres(selectedLength());
      const area = width * length;
      const totalArea = area * quantity;
      const totalPrice = variant ? Number(variant.price) * quantity : 0;

      variantInput.value = variant?.id || '';
      quantityInput.value = String(quantity);
      if (quantityOutput) quantityOutput.textContent = String(quantity);

      const pieceSize = q(hero, '[data-m42-piece-size]');
      const pieceArea = q(hero, '[data-m42-piece-area]');
      const totalAreaEl = q(hero, '[data-m42-total-area]');
      const totalPriceEl = q(hero, '[data-m42-total-price]');
      const buttonPrice = q(hero, '[data-m42-button-price]');
      const stickyPrice = q(root, '[data-m42-sticky-price]');
      const stickyDetails = q(root, '[data-m42-sticky-details]');

      if (pieceSize) pieceSize.textContent = `${width}m × ${length}m`;
      if (pieceArea) pieceArea.textContent = `${area}m²`;
      if (totalAreaEl) totalAreaEl.textContent = `${totalArea}m²`;
      if (totalPriceEl) totalPriceEl.textContent = money(totalPrice);
      if (buttonPrice) buttonPrice.textContent = money(totalPrice);
      if (stickyPrice) stickyPrice.textContent = money(totalPrice);
      if (stickyDetails) stickyDetails.textContent = `${width}m × ${length}m · ${totalArea}m²`;

      const available = Boolean(variant && variant.available);
      if (addButton) {
        addButton.disabled = !available;
        addButton.setAttribute('aria-disabled', String(!available));
      }
      if (stickyAdd) {
        stickyAdd.disabled = !available;
        stickyAdd.setAttribute('aria-disabled', String(!available));
      }
    }

    widthButtons.forEach((button) => {
      button.addEventListener('click', () => {
        widthButtons.forEach((item) => item.classList.remove('active'));
        button.classList.add('active');
        rebuildLengthOptions(preferredLengthNumber);
        updateOrder();
      });
    });

    lengthSelect.addEventListener('change', () => {
      preferredLengthNumber = numericMetres(lengthSelect.value) || preferredLengthNumber;
      updateOrder();
    });

    q(hero, '[data-m42-qty-minus]')?.addEventListener('click', () => {
      quantity = Math.max(1, quantity - 1);
      updateOrder();
    });

    q(hero, '[data-m42-qty-plus]')?.addEventListener('click', () => {
      quantity = Math.min(99, quantity + 1);
      updateOrder();
    });

    /*
      ADD TO CART

      All Green 40 prepares the exact Shopify variant and quantity first.
      Rosyz then handles the actual submission using its native AjaxCart.
    */

    form.addEventListener(
      'submit',
      () => {
        const variant = findVariant();

        if (!variant || !variant.available) {
          return;
        }

        variantInput.value = String(variant.id);
        quantityInput.value = String(quantity);
      }
    );

    const attachRosyzAjaxCart = () => {
      if (
        form.dataset.allGreen40AjaxCartReady === 'true'
      ) {
        return true;
      }

      if (
        !window.jQuery ||
        typeof window.AjaxCart !== 'function'
      ) {
        return false;
      }

      try {
        new window.AjaxCart(
          window.jQuery(form)
        );

        form.dataset.allGreen40AjaxCartReady =
          'true';

        return true;
      } catch (error) {
        console.error(
          'All Green 40 AjaxCart could not initialise.',
          error
        );

        return false;
      }
    };

    if (!attachRosyzAjaxCart()) {
      let ajaxCartAttempts = 0;

      const ajaxCartTimer =
        window.setInterval(() => {
          ajaxCartAttempts += 1;

          if (
            attachRosyzAjaxCart() ||
            ajaxCartAttempts >= 50
          ) {
            window.clearInterval(
              ajaxCartTimer
            );
          }
        }, 100);
    }

    stickyAdd?.addEventListener('click', () => form.requestSubmit());

    rebuildLengthOptions(10);
    updateOrder();
  }

  function initCompare(root) {
    qa(root, '[data-m42-compare]').forEach((compare) => {
      if (compare.dataset.m42Ready === 'true') return;
      compare.dataset.m42Ready = 'true';
      const range = q(compare, 'input[type="range"]');
      range?.addEventListener('input', () => compare.style.setProperty('--pos', `${range.value}%`));
    });
  }

  function initReveal(root) {
    const items = qa(root, '.reveal:not([data-m42-reveal-ready])');
    if (!items.length) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .1 });
    items.forEach((item) => {
      item.dataset.m42RevealReady = 'true';
      observer.observe(item);
    });
  }

  function initLayer(root) {
    qa(root, '[data-m42-layer-section]').forEach((section) => {
      if (section.dataset.m42Ready === 'true') return;
      section.dataset.m42Ready = 'true';
      const video = q(section, 'video.m42-layer-video, video[data-m42-layer-video]');
      if (!video) return;
      const phase = q(section, '[data-m42-layer-phase]');
      const detail = q(section, '[data-m42-layer-detail]');
      const fill = q(section, '[data-m42-layer-fill]');
      const dot = q(section, '[data-m42-layer-dot]');
      let duration = 10;
      let target = 0;
      let ready = false;
      let rafQueued = false;

      function copy(progress) {
        const phaseText = progress < .12 ? 'Complete product' : progress < .43 ? 'Separating construction' : progress < .72 ? 'Construction layers revealed' : progress < .94 ? 'Recombining product' : 'Complete product';
        const detailText = progress < .12 ? 'Scroll to begin separating the All Green 40 construction.' : progress < .43 ? 'The backing components move apart into clearly labelled positions.' : progress < .72 ? 'Primary Backing, Geotextile Grid and PU and/or Latex coating are clearly revealed.' : progress < .94 ? 'Continue scrolling as the construction returns to the finished product.' : 'All Green 40 is complete and ready for the next section.';
        if (phase) phase.textContent = phaseText;
        if (detail) detail.textContent = detailText;
        if (fill) fill.style.height = `${progress * 100}%`;
        if (dot) dot.style.top = `${progress * 100}%`;
      }

      function onScroll() {
        const rect = section.getBoundingClientRect();
        const travel = Math.max(1, section.offsetHeight - innerHeight);
        const progress = clamp(-rect.top / travel);
        target = progress * Math.max(.01, duration - .04);
        copy(progress);
      }

      function tick() {
        if (ready && Number.isFinite(video.duration)) {
          const difference = target - video.currentTime;
          if (Math.abs(difference) > .018) video.currentTime += difference * .34;
        }
        requestAnimationFrame(tick);
      }

      function prepare() {
        duration = Number.isFinite(video.duration) ? video.duration : 10;
        ready = true;
        video.pause();
        onScroll();
      }

      video.addEventListener('loadedmetadata', prepare, { once: true });
      video.addEventListener('canplay', () => { ready = true; video.pause(); }, { once: true });
      if (video.readyState >= 1) prepare();
      addEventListener('scroll', () => {
        if (!rafQueued) {
          requestAnimationFrame(() => { onScroll(); rafQueued = false; });
          rafQueued = true;
        }
      }, { passive: true });
      addEventListener('resize', onScroll, { passive: true });
      onScroll();
      requestAnimationFrame(tick);
    });
  }

  function initCoolTabs(root) {
    qa(root, '[data-m42-cool]').forEach((section) => {
      if (section.dataset.m42Ready === 'true') return;
      section.dataset.m42Ready = 'true';
      const visual = q(section, '[data-m42-cool-visual]');
      qa(section, '[data-m42-cool-mode]').forEach((button) => {
        button.addEventListener('click', () => {
          qa(section, '[data-m42-cool-mode]').forEach((item) => {
            item.classList.remove('active');
            item.setAttribute('aria-selected', 'false');
          });
          button.classList.add('active');
          button.setAttribute('aria-selected', 'true');
          if (visual) visual.dataset.mode = button.dataset.m42CoolMode;
        });
      });
    });
  }

  function initTriweave(root) {
    qa(root, '[data-m42-triweave]').forEach((section) => {
      if (section.dataset.m42Ready === 'true') return;
      section.dataset.m42Ready = 'true';
      const stage = q(section, '[data-m42-blade-stage]');
      const title = q(section, '[data-m42-focus-title]');
      qa(section, '[data-m42-blade]').forEach((button) => {
        button.addEventListener('click', () => {
          qa(section, '[data-m42-blade]').forEach((item) => item.classList.remove('active'));
          button.classList.add('active');
          if (stage) stage.dataset.active = button.dataset.m42Blade;
          if (title) title.textContent = button.dataset.title || '';
        });
      });
    });
  }

  function initSpecs(root) {
    qa(root, '[data-m42-specs]').forEach((section) => {
      if (section.dataset.m42Ready === 'true') return;
      section.dataset.m42Ready = 'true';
      const buttons = qa(section, '[data-m42-spec-tab]');
      const panels = qa(section, '[data-m42-spec-panel]');
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const tab = button.dataset.m42SpecTab;
          buttons.forEach((item) => item.classList.toggle('active', item === button));
          panels.forEach((panel) => {
            const active = panel.dataset.m42SpecPanel === tab;
            panel.hidden = !active;
            if (active && panel.animate) panel.animate([{ opacity: .25, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 260 });
          });
        });
      });
    });
  }

  function initFaq(root) {
    qa(root, '[data-m42-faq-item]').forEach((item) => {
      if (item.dataset.m42Ready === 'true') return;
      item.dataset.m42Ready = 'true';
      const button = q(item, '[data-m42-faq-question]');
      button?.addEventListener('click', () => {
        const open = item.classList.toggle('open');
        button.setAttribute('aria-expanded', String(open));
      });
    });
  }


  function initBackToBuy(root) {
    qa(root, '[data-m42-back-to-buy]').forEach((button) => {
      if (button.dataset.m42Ready === 'true') return;
      button.dataset.m42Ready = 'true';
      button.addEventListener('click', (event) => {
        if (button.tagName === 'A' && button.getAttribute('href') && button.getAttribute('href') !== '#top') return;
        event.preventDefault();
        document.querySelector('[data-m42-hero]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initSticky(root) {
    const sticky = q(root, '[data-m42-sticky]');
    const hero = q(root, '[data-m42-hero]');
    if (!sticky || !hero || sticky.dataset.m42Ready === 'true') return;
    sticky.dataset.m42Ready = 'true';
    const update = () => {
      const rect = hero.getBoundingClientRect();
      sticky.classList.toggle('show', rect.bottom < 80 && scrollY < document.body.scrollHeight - innerHeight - 420);
    };
    addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update, { passive: true });
    update();
  }

  function init(root = document) {
    qa(root, '.m42-page').forEach((page) => {
      initHero(page);
      initCompare(page);
      initReveal(page);
      initLayer(page);
      initCoolTabs(page);
      initTriweave(page);
      initSpecs(page);
      initFaq(page);
      initBackToBuy(page);
    });
    // Sticky and toast are contained in the hero section wrapper.
    qa(document, '.m42-page').forEach(initSticky);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
